export default __webpack_public_path__ + "static/media/credit.5f1b4f0a.svg";